<template>
  <div class="ad-node ad-node--agent" :style="data.height ? { minHeight: data.height + 'px' } : null">
    <Handle v-for="h in data.configHandles || []" :id="h.id" :key="h.id" type="target" :position="Position.Left" :style="{ top: h.top }" />
    <Handle v-for="h in data.toolHandles || []" :id="h.id" :key="h.id" type="source" :position="Position.Right" :style="{ top: h.top }" />

    <div class="ad-agent__icon">
      <Icon name="memory" class="w-6 h-6" />
    </div>
    <div class="ad-agent__body">
      <div class="ad-agent__name" :title="data.name">{{ data.name }}</div>
      <div v-if="data.model" class="ad-agent__model" :title="data.model">{{ data.model }}</div>
    </div>
    <img v-if="data.logo" :src="data.logo" class="ad-node__logo" :alt="data.provider" />
  </div>
</template>

<script>
import { Handle, Position } from '@vue-flow/core';
import Icon from '@/ui-components/Icon.vue';

export default {
  name: 'AgentNode',
  components: { Handle, Icon },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data() {
    return { Position };
  },
};
</script>
